import React from "react";
import { ChannelLogo } from "./Logos";
import { CHANNELS } from "../mock";

export default function LogoMarquee() {
  const items = [...CHANNELS, ...CHANNELS];
  return (
    <section style={{ borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)", background: "var(--card)" }}>
      <div className="container-x" style={{ padding: "22px 24px" }}>
        <div className="flex flex-col md:flex-row md:items-center gap-5">
          <span className="eyebrow" style={{ whiteSpace: "nowrap", flexShrink: 0 }}>
            Built on the tools you already trust
          </span>
          <div className="marquee-mask" style={{ overflow: "hidden", flex: 1, width: "100%" }}>
            <div className="marquee-track">
              {items.map((c, i) => (
                <span
                  key={i}
                  className="flex items-center gap-2.5"
                  style={{ padding: "0 30px", opacity: 0.9, whiteSpace: "nowrap" }}
                >
                  <ChannelLogo name={c.name} />
                  <span style={{ fontSize: 14, fontWeight: 500, color: "var(--ink-soft)" }}>{c.name}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
